import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Box, Button, Paper } from '@material-ui/core';
import styles from './PopMessage.module.css';
import {
  setConfirmPopFlg,
  setConfirmFlg,
  setPopMessage,
} from '../../actions/CommonAction';

class PopMessageComponent extends Component {
  /**
   * はいボタン押下時の処理
   */
  onClickYesButton = async () => {
    const {
      onClickYesFunction,
      setConfirmFlgAct,
      setConfirmPopFlgAct,
    } = this.props;
    setConfirmFlgAct(true);
    setConfirmPopFlgAct(false);
    if (onClickYesFunction) {
      await onClickYesFunction();
    }
  }

  /**
   * いいえボタン押下時の処理
   */
  onClickNoButton = async () => {
    const {
      onClickNoFunction,
      setConfirmFlgAct,
      setConfirmPopFlgAct,
    } = this.props;
    setConfirmFlgAct(false);
    setConfirmPopFlgAct(false);
    if (onClickNoFunction) {
      await onClickNoFunction();
    }
  }

  render() {
    const {
      popMessage,
      confirmPopFlg,
    } = this.props;
    return (confirmPopFlg && (
      <Paper>
        <div className={`${styles.popmessage}`}>
          <div className={`${styles.contents}`}>
            <div className={`${styles.message}`}>
              {popMessage}
            </div>
            <div className={`${styles.button}`}>
              <Box>
                <Button
                  variant="contained"
                  className={`${styles.cancelColor} cancel`}
                  onClick={this.onClickNoButton}
                >
                  いいえ
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  className={`${styles.normalColor}`}
                  onClick={this.onClickYesButton}
                >
                  はい
                </Button>
              </Box>
            </div>
          </div>
        </div>
      </Paper>
    )
    );
  }
}

export default connect(
  (state) => ({
    popMessage: state.common.popMessage,
    confirmPopFlg: state.common.confirmPopFlg,
    onClickYesFunction: state.common.onClickYesFunction,
    onClickNoFunction: state.common.onClickNoFunction,
  }),
  (dispatch) => ({
    setPopMessageAct: (str) => dispatch(setPopMessage(str)),
    setConfirmFlgAct: (bool) => dispatch(setConfirmFlg(bool)),
    setConfirmPopFlgAct: (bool) => dispatch(setConfirmPopFlg(bool)),
  }),
)(PopMessageComponent);
